import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { AuthService } from '@services/auth/auth.service';
import { IntranetService } from '@services/coreservice/intranet.service';
import { ToolsService } from '@services/varios/tools.service';
import Utils from '@utils/utils';
import { CargaFamiliar } from 'src/app/common/interfaces/carga-familiar.interface';
import { DatosPersonalesLite } from 'src/app/common/interfaces/datos-personales-lite.model';
import { Filtros } from 'src/app/common/interfaces/filtros.interface';
import { Funcionario } from 'src/app/common/interfaces/funcionario.model';
import { Licencia } from 'src/app/common/interfaces/licencia.interface';
import { SpinnerService } from 'src/app/components/spinner/spinner.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {


  constructor(private readonly spinnerService: SpinnerService,
    public readonly tools: ToolsService,
    private readonly intranetService: IntranetService,
    private readonly authService: AuthService,
    private readonly matPaginatorIntl: MatPaginatorIntl,
    private readonly _liveAnnouncer: LiveAnnouncer

  ) {

    this.dataLicencias = new MatTableDataSource(this.licencia);
    this.dataCargasFamiliares = new MatTableDataSource(this.cargaFamiliar);
    this.matPaginatorIntl.itemsPerPageLabel = 'Elementos por página';
    this.matPaginatorIntl.lastPageLabel = 'Última Página';
    this.matPaginatorIntl.nextPageLabel = 'Próxima Página';
    this.matPaginatorIntl.firstPageLabel = 'Primera Página';
    this.matPaginatorIntl.previousPageLabel = 'Página Anterior';
    this.matPaginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
      if (length === 0 || pageSize === 0) {
        return `0 de ${length}`;
      }
      length = Math.max(length, 0);

      const startIndex = page * pageSize;
      const endIndex = startIndex < length ?
        Math.min(startIndex + pageSize, length) :
        startIndex + pageSize;
      return `${startIndex + 1} - ${endIndex} de ${length}`;
    };
  }

  public dataLicencias: MatTableDataSource<Licencia> = {} as MatTableDataSource<Licencia>;
  public licencia: Licencia[] = [];
  public dataCargasFamiliares: MatTableDataSource<CargaFamiliar> = {} as MatTableDataSource<CargaFamiliar>;
  public cargaFamiliar: CargaFamiliar[] = [];
  public funcionario: Funcionario = {} as Funcionario;
  public isDisabled: boolean = false;
  public disableLiquidacion: boolean = true;
  public disableCargaFamiliar: boolean = true;
  public disableAntiguedad: boolean = true;
  
  public rutBuscado: string = '';
  selectedColumnCF: string = 'todas'; // Columna seleccionada en el mat-select
  filterValueCF: string = ''; // Valor del input de filtro
  pageSize = 10;

  filtrosCF = [
    { value: 'tipo_Beneficio', text: 'TIPO BENEFICIO' },
    { value: 'afecto_a_Pago', text: 'AFECTO A PAGO' },
    { value: 'valor', text: 'VALOR' },
    { value: 'nombre', text: 'NOMBRE' },
    { value: 'rut', text: 'RUT' },
    { value: 'causante', text: 'CAUSANTE' },
    { value: 'fecha_reconocimiento_formal', text: 'FECHA RECONOCIMIENTO' },
    { value: 'fecha_termino', text: 'FECHA TÉRMINO' },
    { value: 'fecha_extincion', text: 'FECHA EXTINCIÓN' },
    { value: 'motivo_extincion', text: 'MOTIVO EXTINCIÓN' },
    { value: 'estado', text: 'ESTADO' }
  ];

  filtrosExportacionCF = [
    { value: 'tipo_Beneficio', text: 'TIPO BENEFICIO' },
    { value: 'afecto_a_Pago', text: 'AFECTO A PAGO' },
    { value: 'valor', text: 'VALOR' },
    { value: 'nombre', text: 'NOMBRE' },
    { value: 'rut', text: 'RUT' },
    { value: 'causante', text: 'CAUSANTE' },
    { value: 'fecha_reconocimiento_formal', text: 'FECHA RECONOCIMIENTO' },
    { value: 'fecha_termino', text: 'FECHA TÉRMINO' },
    { value: 'fecha_extincion', text: 'FECHA EXTINCIÓN' },
    { value: 'motivo_extincion', text: 'MOTIVO EXTINCIÓN' },
    { value: 'estado', text: 'ESTADO' }
  ];

  displayedColumnsCF: string[] = [
    'tipo_Beneficio',
    'afecto_a_Pago',
    'valor',
    'nombre',
    'rut',
    'causante',
    'fecha_reconocimiento_formal',
    'fecha_termino',
    'fecha_extincion',
    'motivo_extincion',
    'estado'
  ];

  //**************/

  selectedColumn: string = 'todas'; // Columna seleccionada en el mat-select
  filterValue: string = ''; // Valor del input de filtro

  filtros = [
    { value: 'folio', text: 'FOLIO' },
    { value: 'tipoLicencia', text: 'TIPO LICENCIA' },
    { value: 'fechaInicio', text: 'FECHA INICIO' },
    { value: 'fechaTermino', text: 'FECHA TÉRMINO' },
    { value: 'dias', text: 'DÍAS' },
    { value: 'estado', text: 'ESTADO' },
    { value: 'salud', text: 'SALUD' },
    { value: 'numeroResolucion', text: 'NÚMERO RESOLUCIÓN' },
    { value: 'fechaResolucion', text: 'FECHA RESOLUCIÓN' }
  ];

  filtrosExportacion = [
    { value: 'folio', text: 'FOLIO' },
    { value: 'tipoLicencia', text: 'TIPO LICENCIA' },
    { value: 'fechaInicio', text: 'FECHA INICIO' },
    { value: 'fechaTermino', text: 'FECHA TÉRMINO' },
    { value: 'dias', text: 'DÍAS' },
    { value: 'estado', text: 'ESTADO' },
    { value: 'salud', text: 'SALUD' },
    { value: 'numeroResolucion', text: 'NÚMERO RESOLUCIÓN' },
    { value: 'fechaResolucion', text: 'FECHA RESOLUCIÓN' }
  ];

  displayedColumns: string[] = [
    'folio',
    'tipoLicencia',
    'fechaInicio',
    'fechaTermino',
    'dias',
    'estado',
    'salud',
    'numeroResolucion',
    'fechaResolucion'
  ];

  /* ,
    'action'
 */
  anios: number[] = [];
  selectedAnio: number = new Date().getFullYear();
  startDate: string = '01-01-2000'; // Fecha de inicio en formato "dd-MM-yyyy"

  filtrosData: Filtros = {} as Filtros;
  selectedYearCertificadoRenta: number | null = null;
  aniosCertificadoRentas: number[] = [];

  groupedDataRenta: { anio: number, ruta: string }[] = []
  groupedDataLiquidacion: { anio: number, meses: { mes: number, rutas: string }[] }[] = [];
  selectedYearLiquidacion: number | null = null;
  filteredMonths: { mes: number, rutas: string }[] = [];
  selectedMonthLiquidacion: number | null = null;
  monthNames: { [key: number]: string } = {
    1: "Enero",
    2: "Febrero",
    3: "Marzo",
    4: "Abril",
    5: "Mayo",
    6: "Junio",
    7: "Julio",
    8: "Agosto",
    9: "Septiembre",
    10: "Octubre",
    11: "Noviembre",
    12: "Diciembre"
  };

  selectedMes: number = 12;
  encontroFuncionario: boolean = false

  ngOnInit() {
    this.windowSizeItems();
    this.refresh();
  }

  async refresh() {

    let UsrInfo = this.authService.getUserInfo();

    if (this.tools.userInRol(['USUARIO', 'ADMINISTRADOR MDA NACIONAL', 'ADMINISTRADOR MDA REGIONAL'])) {
      await this.focusOutRutFuncionario(UsrInfo.usuario.run + '-' + UsrInfo.usuario.dv);
      this.isDisabled = true;
    } else {
      this.isDisabled = false;
    }
  }

  windowSizeItems() {
    let windowSize = window.innerWidth;
    if (windowSize > 3840) {
      this.pageSize = 30;
    } else if (windowSize <= 3840 && windowSize > 2560) {
      this.pageSize = 25;
    } else if (windowSize <= 2560 && windowSize > 1920) {
      this.pageSize = 20;
    } else if (windowSize <= 1920 && windowSize > 1280) {
      this.pageSize = 15;
    } else if (windowSize <= 1280) {
      this.pageSize = 10;
    }
  }

  generateYears() {
    const startMonth = new Date().getMonth();
    const startYear = parseInt(this.startDate.split('-')[2], 10);
    const currentYear = new Date().getFullYear();

    this.anios = Array.from({ length: currentYear - startYear + 1 }, (_, i) => startYear + i);

    this.selectedAnio = currentYear;
    this.selectedMes = startMonth;

  }

  numberOnly(event: any, maxinput: number): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) || (event.target.value.toString().length == maxinput)) {
      return false;
    }
    return true;
  }

  async focusOutRutFuncionario(event: any) {

    if (event != undefined && event != '' && event != null) {
      if (this.tools.validarRut(event)) {
        if (this.funcionario.rut == event.toString()) {
          return;
        }

        this.rutBuscado = event;

        let spinnerRef = this.spinnerService.start();

        this.licencia = [];
        this.cargaFamiliar = [];
        this.groupedDataLiquidacion = [];
        this.groupedDataRenta = [];
        this.aniosCertificadoRentas = [];
        this.disableLiquidacion = true;
        this.disableCargaFamiliar = true;
        this.disableAntiguedad = true;
        this.encontroFuncionario = false;

        let funcionarioTemp = await this.intranetService.getFuncionarioByRut(event);

        if (funcionarioTemp.nombreCompleto == undefined) {
          this.spinnerService.stop(spinnerRef);
          await this.tools.errorMensaje('Funcionario no encontrado.');
          this.funcionario= {} as Funcionario;
          this.licencia = [];
          this.cargaFamiliar = [];
          this.groupedDataLiquidacion = [];
          this.groupedDataRenta = [];
          this.aniosCertificadoRentas = [];
          this.disableLiquidacion = true;
          this.disableCargaFamiliar = true;
          this.disableAntiguedad = true;
          this.encontroFuncionario = false;
          return;
        } else {

          this.funcionario = funcionarioTemp;
          this.funcionario.isHonorario = this.funcionario.tipoContrato == 'HONORARIOS';
          await this.groupDataByYear();

          this.disableLiquidacion = false;
          this.disableCargaFamiliar = false;

          if (this.funcionario.fechaIngreso != undefined && this.funcionario.fechaIngreso != '') {
            this.startDate = this.funcionario.fechaIngreso;
            this.disableAntiguedad = false;
          }

          if (this.funcionario.fechaInicioCargo == undefined || this.funcionario.fechaInicioCargo == '') {
            this.disableAntiguedad = true;
          }

          this.licencia = this.funcionario.licenciasMedicas;
          this.cargaFamiliar = this.funcionario.cargasFamiliares;

          this.cargaFamiliar.forEach(element => {
            element.tipo_Beneficio = element.tipo_Beneficio.toUpperCase();
            element.causante = element.causante.toUpperCase();
            element.motivo_extincion = element.motivo_extincion.toUpperCase();
            element.estado = element.estado.toUpperCase();
          });

          this.dataLicencias = new MatTableDataSource(this.licencia);
          this.dataLicencias.paginator = this.paginator;
          this.dataLicencias.sort = this.sort;

          this.dataCargasFamiliares = new MatTableDataSource(this.cargaFamiliar);

          this.encontroFuncionario = true;
        }
        this.spinnerService.stop(spinnerRef);
      } else {
        this.selectedMonthLiquidacion = null;
        this.selectedYearLiquidacion = null;
        this.funcionario = {} as Funcionario;
        this.licencia = [];
        this.dataLicencias = new MatTableDataSource(this.licencia);
        this.cargaFamiliar = [];
        this.dataCargasFamiliares = new MatTableDataSource(this.cargaFamiliar);
        this.groupedDataLiquidacion = [];
        this.groupedDataRenta = [];
        this.aniosCertificadoRentas = [];
        this.disableLiquidacion = true;
        this.disableCargaFamiliar = true;
        this.disableAntiguedad = true;
        this.encontroFuncionario = false;
        this.tools.errorMensaje('Ingrese un rut válido');
      }
    } else {
      this.selectedMonthLiquidacion = null;
      this.selectedYearLiquidacion = null;
      this.rutBuscado = '';
      this.funcionario = {} as Funcionario;
      this.licencia = [];
      this.dataLicencias = new MatTableDataSource(this.licencia);
      this.cargaFamiliar = [];
      this.dataCargasFamiliares = new MatTableDataSource(this.cargaFamiliar);
      this.groupedDataLiquidacion = [];
      this.groupedDataRenta = [];
      this.disableLiquidacion = true;
      this.disableCargaFamiliar = true;
      this.disableAntiguedad = true;
      this.encontroFuncionario = false;
    }
  }

  async getLiquidacion() {
    if (this.funcionario.rut != undefined && this.funcionario.rut != '') {
      if (this.selectedYearLiquidacion != null && this.selectedMonthLiquidacion != null) {
        let spinnerRef = this.spinnerService.start();

        let datosFuncionarioLite: DatosPersonalesLite = this.intranetService.llenarFuncionarioLite(this.funcionario);
        datosFuncionarioLite.filtros = {} as Filtros;
        datosFuncionarioLite.filtros.rutasLiquidacion = this.obtenerRutasPorAnioYMes(this.selectedYearLiquidacion, this.selectedMonthLiquidacion)
        datosFuncionarioLite.filtros.mesLiquidacion = this.selectedMonthLiquidacion;
        datosFuncionarioLite.filtros.anioLiquidacion = this.selectedYearLiquidacion;
        await this.intranetService.getLiquidacion(datosFuncionarioLite);

        this.spinnerService.stop(spinnerRef);
      } else {
        await this.tools.errorMensaje('Debe seleccionar el periodo Año y Mes, para Generar PDF.')
      }

    } else {
      await this.tools.errorMensaje('Debe seleccionar un rut de funcionario válido en la pestaña "Datos Personales"');
    }
  }

  async doCertificadoAntiguedad() {
    if (this.funcionario.rut != undefined && this.funcionario.rut != '') {
      let spinnerRef = this.spinnerService.start();

      let datosFuncionarioLite: DatosPersonalesLite = this.intranetService.llenarFuncionarioLite(this.funcionario);
      datosFuncionarioLite.filtros = {} as Filtros;
      await this.intranetService.getCertificadoAntiguedad(datosFuncionarioLite);

      this.spinnerService.stop(spinnerRef);
    } else {
      await this.tools.errorMensaje('Debe seleccionar un rut de funcionario válido en la pestaña "Datos Personales"');
    }
  }

  async doCertificadoSueldo() {
    if (this.funcionario.rut != undefined && this.funcionario.rut != '') {
      let spinnerRef = this.spinnerService.start();

      let datosFuncionarioLite: DatosPersonalesLite = this.intranetService.llenarFuncionarioLite(this.funcionario);
      datosFuncionarioLite.filtros = {} as Filtros;
      datosFuncionarioLite.filtros.rutasCertificadoSueldo = this.obtenerRutasPorCantidad(this.selectedMes);
      datosFuncionarioLite.filtros.mesesCertificadoSueldo = this.selectedMes;
      await this.intranetService.getCertificadoSueldo(datosFuncionarioLite);

      this.spinnerService.stop(spinnerRef);
    } else {
      await this.tools.errorMensaje('Debe seleccionar un rut de funcionario válido en la pestaña "Datos Personales"');
    }
  }

  async doCertificadoRenta() {
    if (this.funcionario.rut != undefined && this.funcionario.rut != '') {
      if (this.selectedYearCertificadoRenta != null) {
        let spinnerRef = this.spinnerService.start();

        let datosFuncionarioLite: DatosPersonalesLite = this.intranetService.llenarFuncionarioLite(this.funcionario);
        datosFuncionarioLite.filtros = {} as Filtros;
        datosFuncionarioLite.filtros.rutaCertificadoRenta = this.groupedDataRenta.filter(x => x.anio == this.selectedYearCertificadoRenta)[0].ruta;
        datosFuncionarioLite.filtros.anioCertificadoRenta = this.selectedYearCertificadoRenta;
        await this.intranetService.getCertificadoRenta(datosFuncionarioLite);

        this.spinnerService.stop(spinnerRef);
      } else {
        await this.tools.errorMensaje('Debe seleccionar el Año, para Generar PDF.')
      }

    } else {
      await this.tools.errorMensaje('Debe seleccionar un rut de funcionario válido en la pestaña "Datos Personales"');
    }
  }

  async groupDataByYear() {
    const groupedMap = new Map<number, { mes: number, rutas: string }[]>();

    let datos = await this.intranetService.getPeriodosFuncionarioByRut(this.funcionario.rut);

    if (Object.keys(datos.filtrosCertificadoRenta).length > 0) {
      this.aniosCertificadoRentas = datos.filtrosCertificadoRenta.map((x: { anio: any; }) => x.anio);
      this.selectedYearCertificadoRenta = datos.filtrosCertificadoRenta[0].anio;
      this.groupedDataRenta = datos.filtrosCertificadoRenta;
    }

    if (Object.keys(datos.filtrosLiquidacion).length > 0) {
      datos.filtrosLiquidacion.forEach((item: { anio: number; mes: any; rutas: any; }) => {
        if (!groupedMap.has(item.anio)) {
          groupedMap.set(item.anio, []);
        }
        groupedMap.get(item.anio)?.push({ mes: item.mes, rutas: item.rutas });
      });

      this.groupedDataLiquidacion = Array.from(groupedMap, ([anio, meses]) => ({ anio, meses }));
      this.selectedYearLiquidacion = this.groupedDataLiquidacion[0].anio;
      this.filteredMonths = this.groupedDataLiquidacion.find(y => y.anio === this.selectedYearLiquidacion)?.meses || [];
      this.selectedMonthLiquidacion = this.groupedDataLiquidacion.find(y => y.anio === this.selectedYearLiquidacion)?.meses[0].mes || null;

      this.disableLiquidacion = false;
      this.disableCargaFamiliar = false;
    } else {
      this.disableLiquidacion = true;
      this.disableCargaFamiliar = true;
    }
  }

  onYearChange() {
    this.filteredMonths = this.groupedDataLiquidacion.find(y => y.anio === this.selectedYearLiquidacion)?.meses || [];
  }

  obtenerRutasPorAnioYMes(anio: number, mes: number): string[] {
    const anioData = this.groupedDataLiquidacion.find(a => a.anio === anio);
    if (!anioData) return [''];
    const mesData = anioData.meses.find(m => m.mes === mes);
    if (!mesData) return [''];

    return mesData.rutas.split(';').map(r => r.trim()).filter(r => r.length > 0);
  }

  obtenerRutasPorCantidad(cant: number): string[] {
    let rutasP: string[] = this.groupedDataLiquidacion.flatMap(a => a.meses.flatMap(m => m.rutas));
    rutasP = rutasP.slice(0, cant);

    const todasLasRutas: string[] = [];
    rutasP.forEach(element => {
      const separadas = element.split(';').map(r => r.trim()).filter(r => r.length > 0);
      todasLasRutas.push(...separadas);
    });

    return todasLasRutas;
  }

  exportToExcel() {

    let spinnerRef = this.spinnerService.start();

    const excelBlob = Utils.exportToExcelSimple(this.dataLicencias.sortData(this.dataLicencias.filteredData, this.sort), this.filtrosExportacion, 'LICENCIAS');
    const now = new Date();
    const fileName = `Licencias_${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}_${now.getHours().toString().padStart(2, '0')}-${now.getMinutes().toString().padStart(2, '0')}-${now.getSeconds().toString().padStart(2, '0')}.xlsx`;

    const link = document.createElement('a');
    link.href = URL.createObjectURL(excelBlob);
    link.download = fileName;
    link.click();

    this.spinnerService.stop(spinnerRef);
  }

  exportToExcelCargasFamiliares() {

    let spinnerRef = this.spinnerService.start();

    const excelBlob = Utils.exportToExcelSimple(this.dataCargasFamiliares.data, this.filtrosExportacionCF, 'CARGAS FAMILIARES');
    const now = new Date();
    const fileName = `CargasFamiliares_${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}_${now.getHours().toString().padStart(2, '0')}-${now.getMinutes().toString().padStart(2, '0')}-${now.getSeconds().toString().padStart(2, '0')}.xlsx`;

    const link = document.createElement('a');
    link.href = URL.createObjectURL(excelBlob);
    link.download = fileName;
    link.click();

    this.spinnerService.stop(spinnerRef);
  }

  applyFilter(): void {

    const filterValueLower = this.filterValue.trim().toLowerCase();

    if (this.selectedColumn == 'todas') {
      this.clearFilter();
    } else {
      // Aplicar el filtro a la fuente de datos
      this.dataLicencias.filterPredicate = (data: any, filter: string) => {
        let columnValue = data[this.selectedColumn].toString().toLowerCase();
        return Utils.removeAccentsOfString(columnValue).includes(Utils.removeAccentsOfString(filter));
      };
    }

    // Forzar a que la fuente de datos filtre nuevamente
    this.dataLicencias.filter = filterValueLower;
  }

  clearFilter() {
    // Reset the filterPredicate to its default value
    this.dataLicencias.filterPredicate = this.defaultFilterPredicate;
    this.dataLicencias.filter = '';
  }

  // Default filter predicate function
  defaultFilterPredicate(data: any, filter: string): boolean {
    const dataStr = Object.keys(data).reduce((currentTerm, key) => {
      // Handle cases where data[key] is null/undefined
      if (data[key] !== null && data[key] !== undefined) {
        return currentTerm + data[key].toString().toLowerCase();
      } else {
        return currentTerm;
      }
    }, '');

    // Transform the filter by converting it to lowercase and removing whitespace
    const transformedFilter = Utils.removeAccentsOfString(filter.trim()).toLowerCase();
    return Utils.removeAccentsOfString(dataStr).indexOf(transformedFilter) !== -1;
  }

  @ViewChild(MatTable, { static: true }) table: MatTable<any> = Object.create(this.licencia);
  searchText: any;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator = Object.create(null);

  @ViewChild(MatSort) sort: MatSort = new MatSort();

  ngAfterViewInit() {
    this.dataLicencias.sort = this.sort;
  }

  announceSortChange(sortState: Sort) {
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }
}